import React from 'react';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { aiAlertMetricSelector, includesAiAlertEventWindowSelector } from '@store/trends/aiAlerts/selectors';
import { SlidersOutlined } from '@ant-design/icons';
import { IconWrapper, DiagWrapper } from '../styled';
import { CHART_TYPE } from '@components/metrics-panel-hz/hooks/utils';
import LegendIcon from '@icons/common/legend.svg';

function LegendToggle({ metric, onToggle, chartMode }) {

  const includesAlertWindow = useSelector(includesAiAlertEventWindowSelector);
  const alertMetric = useSelector(aiAlertMetricSelector);
  const showLegend = includesAlertWindow && metric === alertMetric && chartMode === CHART_TYPE.LINE;

  const handleClick = () => {
    onToggle();
  }

  return showLegend ? (
    <Tooltip title="Legend">
      <DiagWrapper>
        <IconWrapper onClick={handleClick}>
          <LegendIcon />
        </IconWrapper>
      </DiagWrapper>
    </Tooltip>
  ) : null;

}

export default LegendToggle;
